<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <QuestionBase class="driver-question">
    <template v-slot:question>
      <slot name="question">{{ updatedQuestion }}</slot>
    </template>
    <template v-slot:question-options>
      <div class="lgrm-drivers" :class="{ 'lgrm-vertical': vertical }">
        <div
          class="lgrm-driver"
          :class="{ 'lgrm-selected': selected.indexOf(option.id) > -1 }"
          v-for="option in options.filter(d => d.deleted === false)"
          :key="option.id"
          @click="select(option)"
          ref="drivers"
        >
          <div :style="getDriverBorderStyle(option)" class="lgrm-driver-text">
            {{ option.label }}
          </div>
          <div :style="getDriverBgStyle(option)" class="lgrm-driver-bg">
            {{ option.label }}
          </div>
        </div>
      </div>
    </template>
  </QuestionBase>
</template>

<script>
import QuestionBase from './QuestionBase'
import colorMixin from '../../../../src/mixins/colors'
export default {
  name: 'DriverQuestion',
  mixins: [colorMixin],
  components: { QuestionBase },
  props: {
    question: {
      type: String,
      default: 'Overall how satisfied are you with {brand_name}'
    },
    options: {
      type: Array,
      default: function() {
        return [
          { id: 1, label: 'Option 1', order_no: 1 },
          { id: 2, label: 'Option 2', order_no: 2 },
          { id: 3, label: 'Option 3', order_no: 3 }
        ]
      }
    },
    brandName: String,
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    color: { type: String, default: 'red' },
    borderColor: { type: String },
    textColor: { type: String },
    multiple: { type: Boolean, default: false },
    animationEnabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    verticalPadding: { type: Number, default: 8 }
  },
  data: function() {
    return {
      selected: this.value,
      vertical: false
    }
  },
  mounted(){
    if(this.animationEnabled)
      this.$anime({
        targets: this.$refs.drivers,
        direction: 'alternate',
        loop: false,
        easing: 'spring(1, 80, 10, 0)',
        delay: this.$anime.stagger(100),
        keyframes: [
          {translateY: -10},
          {translateY: 5},
          {translateY: 0},
        ],
      });
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandName)
        return this.question.replace('{brand_name}', this.brandName)
      return this.question
    },

  },
  methods: {
    select: function(option) {
      if (this.readonly) return
      const index = this.selected.indexOf(option.id)
      if (index > -1) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(option.id)
      }
      this.$emit('change', this.selected)
    },
    getDriverBorderStyle: function(option) {
      const stl = {}
      stl.color = '#000'
      stl.border = '1px solid ' + (this.borderColor || this.color)
      stl.padding = this.verticalPadding + 'px 20px'
      if (this.selected.indexOf(option.id) > -1) {
        stl.border = '1px solid ' + this.color
        if (this.isColorLighter(this.color)) {
          stl.color = '#000'
        } else {
          stl.color = '#fff'
        }
      }
      else{
       if(this.textColor){
         stl.color = this.textColor
       }
      }
      return stl
    },
    getDriverBgStyle: function(option) {
      const stl = {}
      stl.border = '1px solid ' + (this.borderColor || this.color)
      // stl.color = this.color
      stl.background = this.color
      stl.padding = this.verticalPadding + 'px 20px'
      if (this.selected.indexOf(option.id) > -1) {
        stl.border = '1px solid ' + this.color
        stl.background = this.color
        if (this.isColorLighter(this.color)) {
          stl.color = '#000'
        } else {
          stl.color = '#fff'
        }
      }
      return stl
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-drivers {
    display: inline-block
    text-align center
    font-size 16px
    .lgrm-driver {
        margin 5px
        border-radius 20px
        display inline-block
        box-sizing border-box
        cursor pointer
        position relative
        .lgrm-driver-text {
            border-radius 20px
            padding 5px 20px
            top: 0
            z-index 2
        }
        .lgrm-driver-bg {
            opacity .05
            position absolute
            border-radius 20px
            padding 5px 20px
            top: 0
            z-index 1
        }
        &.lgrm-selected {
            .lgrm-driver-bg {
                opacity 1
            }
        }
    }
}
</style>
